<template>
  <v-container grid-list-xl>
    <h2 class="pl-4">
      <span>AllGames</span>
      <span class="green--text">Portfolio</span>
    </h2>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-dialog
        v-model="project.dialog"
        lazy
        max-width="800"
        v-for="project in AllGames"
        :key="project.title"
      >
        <template v-slot:activator="{ on }">
          <v-flex xs12 sm6 md4 lg4 xl4 v-on="on">
            <v-card hover flat color="transparent">
              <v-img
                :src="project.poster"
                aspect-ratio="1.7778"
                contain
                :alt="project.title"
                lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif"
              ></v-img>
              <v-card-title primary-title class="cardTitle">{{project.title}}</v-card-title>
            </v-card>
          </v-flex>
        </template>
        <v-card v-if="project.dialog">
          <v-card-title class="cardTitle">
            {{project.title}}
          </v-card-title>
          <v-card-text>
            <h3>Link</h3>
          </v-card-text>
          <v-card-text>
            <a :href="project.link">{{project.link}}</a>
          </v-card-text>
          <v-card-text>
            <h3>Description</h3>
          </v-card-text>
          <v-card-text>
            <p>{{project.description}}</p>
          </v-card-text>
          <v-card-text>
            <h3>Demo</h3>
          </v-card-text>
          <v-card-media v-if="project.demo">
            <div class="iframe-wrapper">
              <iframe :src="project.href" allowfullscreen allowtransparency allow="autoplay" ></iframe>
            </div>
          </v-card-media>
          <v-card-media v-if="!project.demo">
            <v-img contain max-height="500px" :src="project.demo_image"></v-img>
          </v-card-media>
          <v-card-text>
            <!-- <h3 class="headline mb-0">
              <span>Technology</span>
              <span class="right" >Role</span>
            </h3>
             <v-chip color="green" text-color="white">{{project.tech.tech1}}</v-chip>
            <v-chip color="green" text-color="white">{{project.tech.tech2}}</v-chip>
            <v-chip class="right" color="green" text-color="white">{{project.role}}</v-chip> -->
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  metainfo: {
    title: 'AllGames Portfolio',
    titleTemplate: "%s ← Mathieu's Space",
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        name: 'description',
        content:
          "Mathieu Baesen's AllGames portfolio"
      },
      { charset: 'utf-8' },
      { property: 'og:title', content: "Mathieu' Space" },
      { property: 'og:site_name', content: "Mathieu' Space" },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://Mathieu.space' },
      {
        property: 'og:description',
        content: "Mathieu Baesen's AllGames portfolio"
      }
    ]
  },
  data () {
    return {
      dialog: false,
      AllGames: [
        {
          dialog: false,
          title: '(JDR) Nechronica - The Code',
          poster: 'https://static.miraheze.org/nechronicawiki/0/01/Splash.png',
          demo: false,
          demo_image: '',
          href: '',
          description: 'Écriture d\'un scénario de jeux de rôles d\'une quinzaine de parties autour du système Nechronica.',
          link: 'https://docs.google.com/document/d/1fLE8p7G5jwSmApM49jXECP5R7nHQHI2HWLlSq_5aNVA/edit?usp=sharing',
          date: '20/01/2022',
          tech: {
            tech1: 'JDR',
            tech2: 'Scénario',
            tech3: '',
            tech4: ''
          }
        },
      ]
    }
  }
}
</script>

<style  scoped>
@import "../../../node_modules/vue-plyr/dist/vue-plyr.css";
.cardTitle{
  text-align: center;
  color: green ;
  font-size: x-large;
  justify-content: center;
}
.iframe-wrapper {
  position: relative;
  height: 0;
  padding-top: 56.25%;
  overflow: hidden;
  margin: 3%;
}

.iframe-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
